export function topicsApiPath(propertyId: string): string {
	return `/api/common/properties/${propertyId}/topics`
}

export function topicApiPath(propertyId: string, topicId: string): string {
	return `${topicsApiPath(propertyId)}/${topicId}`
}
